<template>
  <div>
    <van-popup class="send-main" v-model="messageShow">
        <div class="send-email-container">
            <div class="top-email-icon">
                <p v-for="item in pdfList" :key="item.id">
                    <span class="van-ellipsis tip-text">{{ item.title }}</span>
                    <span>{{ item.size }}</span>
                    <span @click="handleCancel(item)" class="iconfont icon-quxiao icon-col"></span>
                </p>
                <p class="m-t-20">总和: {{ sumTotal }}MB</p>
                <p v-if="pdfList.length == 0">暂无选择内容</p>
            </div>
            <div class="main-btn">
                <button class="send-container btn-cal" @click.stop="messageShow = false">取消</button>
                <button class="send-container" @click.stop="handleSure">确定</button>
            </div>
        </div>
    </van-popup>
    <!-- 邮箱分享 -->
    <share-email ref="shareEmail" :pdfIds="ids" @setEmail="setEmail"></share-email>
  </div>
</template>

<script>
import { setdownShare } from '@/api/polymerize'
import shareEmail from '@/views/polymerize/components/shareEmail'
export default {
    components: { shareEmail },
     props: {
        title: {
            type: String,
            default: '下载成功'
        },
        pdfList: {
            type: Array,
            default: []
        },
        isModel: {
            type: Number,
            default: 0
        },
        sumTotal: {

        },
        isEmail: {

        }
    },
    data() {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            id: '',
            messageShow: false, // 显示
            ids: [],
            
        }
    },
    created() {
        let { id } = this.$route.query
        this.id = id
    },
    methods: {
        showPdfList() {
            this.messageShow = true
        },
        handleCancel(item) {
            
            this.$emit('handleCancelPdf',item)
        },
        setEmail(email) { // 发送邮箱记录
            this.setDownShare('2',email)
        },
        handleSure() { // 确定
            if (this.pdfList.length == 0) {
                this.$toast('请先选择再进行下载')
                return
            }
            this.ids = this.pdfList.map(val => {
                return val.id
            })
            
            
            if (this.isModel == '1') { // ios
                this.setDownShare('1')
                this.$refs.shareEmail.downorshare = '1' //  邮件 -- 下载
                this.$refs.shareEmail.showEmail()
            } else { // 安卓
                // console.log('安卓下载',this.checkPicList)
                if (this.isEmail) {
                    this.$refs.shareEmail.downorshare = '2' //  邮件 -- 下载
                    this.$refs.shareEmail.showEmail()
                } else {
                    this.$emit('downFile')
                }
                
            }
            this.messageShow = false
        },
        setDownShare(action,value) {
            let para = {
                type: 1,
                type_id: this.id,
                action: action, // 1 下载 2 分享
                value: value || '',
                user_id: this.$store.state.user.id ? this.$store.state.user.id : this.$route.query.uid,
                pdf_id: this.ids
            }
            console.log('分享的哈哈',para);
            setdownShare(para).then(res => {})
        },
    }
}
</script>

<style lang="scss" scoped>

 .send-main {
    border-radius: 4px;
    .send-email-container{
        width: rem(297);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: #fff;
        margin: 0 auto;
    }
    .top-email-icon {
        width: 100%;
        height: rem(300);
        padding: rem(20) rem(20);
        overflow: hidden;
        overflow-y: auto;
        p {
            display: flex;
            justify-content: space-between;
            margin: rem(20) 0;
        }
        .m-t-20 {
            margin-top: rem(40);
        }
        .tip-text {
            width: rem(179);
        }
    }
    .main-btn {
        display: flex;
    }
    .send-container{
        display: block;
        width: rem(114);
        height: rem(49);
        font-size: 13px;
        margin-bottom: rem(38);
        outline: none;
        border: none;
        background: #6CC5DB;
        color: #FEFEFE;
        border-radius:4px;
    }
    .btn-cal {
        margin-right: rem(8);
        background-color: #ccc;
    }
}

</style>